var _rect, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembersBenefit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 72,
    height: 72,
    rx: 24,
    fill: "#F0F3F6"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 24,
    fill: "#F0F3F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9814 31.863C41.1764 21.9373 52.1552 25.7117 52.1552 25.7117C52.1552 25.7117 60.5478 28.0946 63.0071 34.3478C65.4665 40.601 62.6793 48.0883 61.8956 52.001C61.1118 55.9137 52.1552 57.2599 46.9864 53.1671C41.8177 49.0743 42.4282 48.5893 42.4282 48.5893C42.4282 48.5893 42.554 47.5396 43.2118 46.9915",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9814 31.863C41.1764 21.9373 52.1552 25.7117 52.1552 25.7117C52.1552 25.7117 60.5478 28.0946 63.0071 34.3478C65.4665 40.601 62.6793 48.0883 61.8956 52.001C61.1118 55.9137 52.1552 57.2599 46.9864 53.1671C41.8177 49.0743 42.4282 48.5893 42.4282 48.5893C42.4282 48.5893 42.554 47.5396 43.2118 46.9915",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1607 21.8285L22.3833 22.8776C22.3833 22.8776 21.7569 22.4416 21.3062 22.8279C20.8554 23.2142 21.2156 24.2159 21.8447 24.5191C22.4739 24.8223 22.8481 24.8223 22.8481 24.8223C22.8481 24.8223 23.568 27.2129 24.2158 28.0183C24.8637 28.8237 26.6014 29.6015 26.6014 29.6015H30.2137V27.113C30.2137 27.113 30.9709 25.5928 30.9709 24.5122C31.5722 24.3365 32.6583 23.7019 32.4784 22.3791C32.003 21.4365 31.0863 22.3791 31.0863 22.3791L31.2091 18.8065L27.3169 17.1886L22.1607 21.8285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7011 27.0759L23.8318 27.0022L23.7011 27.0759ZM30.5828 26.3584L30.4448 26.2994L30.5828 26.3584ZM22.013 21.6565C22.4726 24.2804 22.9892 26.1182 23.5704 27.1495L23.8318 27.0022C23.2781 26.0198 22.7678 24.2274 22.3085 21.6047L22.013 21.6565ZM23.5704 27.1495C23.9778 27.8724 24.4958 28.5075 25.1115 28.9459L25.2855 28.7015C24.715 28.2953 24.224 27.6982 23.8318 27.0022L23.5704 27.1495ZM29.7638 28.061C30.2004 27.5091 30.5136 26.9015 30.7207 26.4174L30.4448 26.2994C30.2442 26.7684 29.9434 27.3505 29.5285 27.8749L29.7638 28.061ZM30.7207 26.4174C30.881 26.0425 31.0104 25.4049 31.1149 24.5208C31.2199 23.6318 31.3012 22.4786 31.359 21.0625L31.0592 21.0503C31.0016 22.4626 30.9207 23.6073 30.8169 24.4856C30.7126 25.3687 30.5866 25.968 30.4448 26.2994L30.7207 26.4174Z",
    fill: "#0F0B28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5811 17.6375C30.6342 17.6375 32.2986 16.0108 32.2986 14.0042C32.2986 11.9976 30.6342 10.3709 28.5811 10.3709C26.528 10.3709 24.8636 11.9976 24.8636 14.0042C24.8636 16.0108 26.528 17.6375 28.5811 17.6375Z",
    fill: "#FF9A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1383 22.3686C31.1383 22.3686 31.7769 21.5933 32.3021 22.1266C32.8273 22.6599 32.1189 24.5191 30.9799 24.5191",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2759 22.5042C22.2759 22.5042 26.6944 21.3169 27.9139 18.554C29.4225 20.6664 31.2091 21.4346 31.2091 21.4346C31.2091 21.4346 31.6573 19.8951 31.4049 18.1455C31.1526 16.3959 29.8516 15.1807 28.3225 14.937C26.7228 13.7085 24.2147 14.4164 22.6036 17.1334C20.9926 19.8504 22.2759 22.5042 22.2759 22.5042Z",
    fill: "#FF9A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3415 22.8895C22.3415 22.8895 21.7021 22.3471 21.1339 22.8895C20.5656 23.432 21.9553 24.9611 22.8481 24.8121",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5544 23.7203L21.5969 23.4076",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0863 23.2669L31.7108 22.8776",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7828 44.6881C41.7828 44.6881 42.2702 47.7022 41.0755 49.7994C39.8808 51.8966 31.2946 55.8897 28.5811 56.4358C25.8677 56.9819 21.0014 55.746 21.0014 55.2015C21.0014 54.657 25.4488 54.7948 25.8677 54.3752C24.2728 52.6702 24.1478 51.6077 25.4478 52.2098C26.7478 52.8119 27.1839 53.5767 28.5811 53.5767L37.3911 48.8956L36.9715 45.2168L41.7828 44.6881Z",
    fill: "white",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6773 20.724C21.6773 20.724 25.0875 18.5145 26.2866 16.3399",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2137 31.0503C30.2137 31.0503 36.3346 33.1232 38.1722 34.5549C40.0098 35.9866 42.4078 45.0362 42.4078 45.0362L36.5848 45.421L35.8597 42.7066V47.6107L36.9265 52.8119H20.1779L20.5953 46.4034L19.2095 45.0362L17.5219 49.4516L12.202 47.3606C12.202 47.3606 14.3695 38.1921 16.6596 35.9771C18.9497 33.7621 24.4654 31.4255 24.4654 31.4255C24.4654 31.4255 24.1049 32.9413 24.8637 33.9153C26.1913 35.6196 29.8964 36.4828 30.8052 33.5338C31.2091 32.223 30.2137 31.0503 30.2137 31.0503Z",
    fill: "#CFC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9428 21.7621C21.9428 21.7621 25.6755 19.8002 26.9879 17.8693",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2137 27.1177C30.2137 27.1177 30.2137 30.1582 30.2137 31.0503C30.2137 31.9425 30.8052 32.7359 30.8052 32.7359",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1913 21.2708C26.1913 21.2708 26.4819 22.1176 26.4819 23.2155C26.4819 24.3135 26.1913 25.6488 26.3366 25.8792C26.4819 26.1095 27.3169 25.8792 27.3169 25.8792",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4654 14.9044C24.4654 14.9044 27.4934 13.6629 28.5812 14.7057C30.4664 15.0214 31.2091 16.9992 31.2091 16.9992",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5706 39.4155C19.5706 39.4155 18.3178 42.3524 18.7354 43.6943C19.153 45.0362 20.5953 46.4034 20.5953 46.4034L20.1779 52.8119",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.152 27.162C26.152 27.162 26.7576 27.4768 27.7353 26.9425",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7435 33.9232C10.7435 33.9232 11.3981 45.6702 11.7349 47.5899C12.8917 54.1845 16.9756 52.6477 17.467 49.5763C17.9584 46.5049 14.0535 33.3993 14.0535 33.3993C14.0535 33.3993 14.782 31.3391 14.9085 29.7631C14.9887 28.7639 15.0746 27.8895 15.1268 27.3832C15.1529 27.13 14.966 26.9044 14.7123 26.8839C14.5113 26.8676 14.3239 26.9866 14.2532 27.1755L13.4883 29.2195L12.9367 24.8128C12.911 24.6077 12.7366 24.4538 12.5299 24.4538C12.3001 24.4538 12.1151 24.6427 12.12 24.8725L12.1969 28.4799L11.5376 24.5338C11.4994 24.3057 11.288 24.1484 11.0586 24.1775C10.8335 24.206 10.6691 24.4043 10.6828 24.6308L10.924 28.6157L10.1532 25.1249C10.0994 24.8815 9.86625 24.7213 9.61976 24.7585C9.35703 24.7982 9.17828 25.0461 9.22364 25.3079L9.90135 29.2195L8.97632 27.0703C8.87152 26.8268 8.59632 26.7057 8.34602 26.793C8.08281 26.8848 7.94314 27.1712 8.0336 27.4349C8.37279 28.4236 9.13603 30.6761 9.3322 31.4903C9.58661 32.5462 10.7435 33.9232 10.7435 33.9232Z",
    fill: "white",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6136 28.7968C13.6136 28.7968 13.3328 29.6663 12.902 30.2556C12.4712 30.845 11.1435 30.9944 10.7904 31.9827",
    stroke: "#0F0B28",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83337 29.4195C9.83337 29.2272 10.7904 28.238 12.7514 28.5491",
    stroke: "#0F0B28",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7801 49.2632C36.9695 49.6889 39.1976 50.0727 39.9401 53.3635C40.6826 56.6542 41.558 60.2086 41.558 60.2086C41.558 60.2086 42.6407 61.13 43.1131 61.3902C43.9205 61.8349 44.6017 61.8807 44.5431 62.1668C44.4036 62.847 41.444 62.3342 40.1503 62.3342C38.8567 62.3342 38.9744 60.3464 38.9744 60.3464C38.9744 60.3464 37.4632 57.0615 36.3769 53.5738L35.208 53.5436C35.208 53.5436 34.0171 51.0228 35.7801 49.2632Z",
    fill: "white",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5007 53.6274H35.4736C34.1634 51.4546 35.7373 49.2743 36.0254 49.2743C36.3135 49.2743 32.5007 48.2161 32.5007 48.2161L31.7675 46.8717C31.7675 46.8717 23.2908 47.4197 23.0443 47.4197C22.7978 47.4197 22.0451 54.5022 24.7983 55.1043C27.5516 55.7064 28.5386 54.4345 28.5386 54.4345L32.5007 53.6274Z",
    fill: "#FF9A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0556 49.4516L29.1389 50.1472",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3171 50.4823C31.5065 50.9163 32.0995 51.5224 32.7332 54.1042C33.367 56.6859 34.1721 60.4492 34.1721 60.4492C34.1721 60.4492 34.9983 61.2689 35.5906 62.7819C36.0022 63.8333 35.121 64.1078 34.7279 63.1808C34.8124 64.1048 33.9762 63.8931 33.5815 63.8931C32.2879 63.8931 31.7675 61.2238 31.7675 61.2238C31.7675 61.2238 30.2563 57.8746 29.1701 54.3186L28.0157 54.545C28.0157 54.545 26.624 51.6122 28.8341 50.1884C29.4254 50.2393 29.9198 50.3372 30.3171 50.4823Z",
    fill: "white",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7563 60.3667C39.7563 60.3667 39.7696 61.1809 40.4453 61.1809",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2901 63.8162C34.1801 63.6815 34.0246 63.1833 34.0246 63.1833",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5986 63.8162L33.434 63.2214",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9624 63.7023V63.1833",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8677 37.6124C25.8677 37.6124 24.1841 37.9089 23.6218 38.1916C22.5648 38.7232 22.0644 39.5714 21.8347 40.6229C21.6545 41.4478 21.6786 42.7074 22.3836 43.6152C22.5142 45.143 22.7622 49.2632 22.7622 49.2632L32.5007 48.2161C32.5007 48.2161 31.7215 43.3573 31.3988 41.7134L34.0557 41.9311L34.2912 39.1618C34.2912 39.1618 32.0532 38.486 30.6868 37.9544C30.0037 37.6887 25.8677 37.6124 25.8677 37.6124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3988 41.7134L31.7633 39.6823",
    stroke: "#0F0B28",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4116 39.4681L35.7637 39.675L39.0814 33.5341C39.0814 33.5341 39.0814 32.7115 39.0814 32.0107C39.0814 31.5308 39.1973 30.942 39.2704 30.6183C39.3028 30.4752 39.4309 30.3764 39.5777 30.3764C39.7427 30.3764 39.8812 30.5006 39.8992 30.6646L40.0606 32.1336L41.1479 29.9588C41.2249 29.8047 41.4128 29.7429 41.5663 29.8213C41.6994 29.8894 41.765 30.0427 41.7223 30.186L41.2878 31.6435L42.2206 30.1787C42.3086 30.0406 42.484 29.9872 42.634 30.0528C42.8023 30.1265 42.8788 30.3228 42.8048 30.4909L42.082 32.1336L43.2266 31.0102C43.3394 30.8995 43.5186 30.8949 43.637 30.9995C43.7584 31.1069 43.7731 31.2911 43.6703 31.4163L42.3734 32.9955L43.6364 32.2606C43.7593 32.1891 43.9167 32.2246 43.997 32.3422C44.0733 32.454 44.0556 32.6047 43.9543 32.6946C43.4763 33.1186 42.1324 34.2851 41.2878 34.7658C40.5605 36.2416 38.4278 42.1531 37.1654 42.468C35.9029 42.7829 33.6673 42.1906 33.6673 42.1906L34.4116 39.4681Z",
    fill: "white",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0728 38.1916C27.0728 38.1916 27.7005 40.0041 28.885 39.8395C30.0694 39.675 29.9196 38.4434 29.9196 38.4434",
    stroke: "#0F0B28",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3157 32.7359L25.8677 33.2641",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9244 37.597C24.8282 36.5649 24.8777 35.2561 24.7658 34.476C24.0673 34.3608 23.595 33.192 23.9706 32.3029C24.2209 31.7102 24.5851 31.6034 25.0633 31.9824C24.9774 30.2478 25.9565 29.3804 28.0005 29.3804C31.0664 29.3804 31.8295 31.1071 31.4479 33.3628C31.0664 35.6184 31.6499 35.4113 31.4479 36.7674C31.2459 38.1235 29.2861 39.3839 27.0387 38.3336",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9244 37.597C24.8282 36.5649 24.8777 35.2561 24.7658 34.476C24.0673 34.3608 23.595 33.192 23.9706 32.3029C24.2209 31.7102 24.5851 31.6034 25.0633 31.9824C24.9774 30.2478 25.9565 29.3804 28.0005 29.3804C31.0664 29.3804 31.8295 31.1071 31.4479 33.3628V33.3628C31.0664 35.6184 31.6499 35.4112 31.4479 36.7674C31.2459 38.1235 29.2861 39.3839 27.0387 38.3336",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0936 32.4195C25.4747 32.937 25.3623 34.4229 25.6762 34.5043C25.9901 34.5857 25.811 32.1742 26.019 32.0452C26.2271 31.9162 26.9009 31.5883 27.1755 30.7844C27.9987 31.5285 29.1424 32.3541 31.7452 32.0452C31.7452 32.0452 31.9394 30.297 30.4458 28.9416C28.9523 27.5863 26.4043 27.7944 25.2587 29.1004C23.4104 29.243 23.9065 32.8823 23.9065 32.8823C23.9065 32.8823 24.5125 31.8728 25.0936 32.4195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2422 32.2137C31.2422 32.2137 29.9479 31.7073 29.4193 30.5542",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5809 32.2777C29.5809 32.2777 28.3594 31.6209 27.9785 30.4135",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7165 34.5063C29.7165 34.5063 29.8185 35.2656 30.1129 35.5128C30.4073 35.76 29.9052 36.0026 29.9052 36.0026",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4117 33.6026C30.4117 33.6026 30.9339 33.296 31.3259 33.598",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.519 33.6536C27.519 33.6536 28.0717 33.3006 28.5386 33.6536",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7983 33.4682L24.3054 33.081",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2217 36.7866C30.2217 36.7866 29.3325 36.825 28.8753 36.6379C28.8753 36.6379 29.0414 37.3141 29.4677 37.3141C29.894 37.3141 30.2217 36.7866 30.2217 36.7866Z",
    fill: "#FF9A7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8833 48.5204C38.303 48.5204 40.2646 46.6032 40.2646 44.2383C40.2646 41.8734 38.303 39.9562 35.8833 39.9562C33.4636 39.9562 31.502 41.8734 31.502 44.2383C31.502 46.6032 33.4636 48.5204 35.8833 48.5204Z",
    fill: "#6C5DD3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6849 43.4354L27.1677 44.4984L34.043 47.682C34.043 47.682 34.9428 47.2314 35.5243 47.0747C35.8935 46.9752 36.2563 46.8501 36.472 46.772C36.5875 46.7302 36.7171 46.7758 36.7789 46.8819C36.8427 46.9917 36.8138 47.1319 36.7118 47.2075L36.1367 47.6338H38.7976C38.7976 47.6338 37.2345 49.4516 35.8992 49.4516C34.564 49.4516 33.7818 49.1619 33.7818 49.1619C33.7818 49.1619 27.3432 47.9941 25.9205 47.0747C24.4978 46.1554 23.8015 45.0853 23.8015 45.0853",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6849 43.4354L27.1677 44.4984L34.043 47.682C34.043 47.682 34.9428 47.2314 35.5243 47.0747C35.8935 46.9752 36.2563 46.8501 36.472 46.772C36.5875 46.7302 36.7171 46.7758 36.7789 46.8819V46.8819C36.8427 46.9917 36.8138 47.1319 36.7118 47.2075L36.1367 47.6338H38.7976C38.7976 47.6338 37.2345 49.4516 35.8992 49.4516C34.564 49.4516 33.7818 49.1619 33.7818 49.1619C33.7818 49.1619 27.3432 47.9941 25.9205 47.0747C24.4978 46.1554 23.8015 45.0853 23.8015 45.0853",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3054 39.0224C24.3054 39.0224 25.3667 40.2082 26.3448 42.1406L26.9581 43.2853L23.8015 45.0853L22.7622 43.7593",
    stroke: "#0F0B28",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1389 55.2977C29.1389 55.2977 25.9933 52.8119 25.2259 52.8119C24.4585 52.8119 26.0556 54.4345 26.0556 54.4345C26.0556 54.4345 21.241 54.9949 22.3225 55.2977C23.4041 55.6006 24.4311 55.4358 24.4311 55.4358",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1389 55.2977C29.1389 55.2977 25.9933 52.8119 25.2259 52.8119C24.4585 52.8119 26.0556 54.4345 26.0556 54.4345C26.0556 54.4345 21.241 54.9949 22.3225 55.2977C23.4041 55.6006 24.4311 55.4358 24.4311 55.4358",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0606 32.1336L40.7541 33.4682",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8963 23.7882L49.6697 19.0811C49.6697 19.0811 50.9579 18.9745 50.9856 17.2283C51.0134 15.4821 48.9227 16.1598 48.9247 16.0354C48.9267 15.911 46.0495 12.458 46.0495 12.458L39.7581 13.4893C39.7581 13.4893 39.5589 21.0826 40.9527 22.2438C41.801 23.2535 43.8139 22.9613 43.8139 22.9613C43.8139 22.9613 44.4406 23.5634 44.6004 23.6659C44.7602 23.7684 49.8963 23.7882 49.8963 23.7882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9126 13.4069C39.9126 13.4069 39.533 21.8761 41.6395 22.7367C42.667 23.1565 44.185 23.0042 46.1934 22.2797",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5598 17.7418L50.2903 17.0412",
    stroke: "#CFC8FF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1615 16.778C41.1615 16.778 41.4649 17.5653 41.3252 18.193C41.1856 18.8206 40.7417 20.0494 40.8925 20.3C41.0432 20.5507 41.9494 20.1297 41.9494 20.1297",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5362 13.276C38.5362 13.276 36.4895 15.1727 40.1859 15.3927C43.8823 15.6126 45.811 14.225 45.811 14.225C45.811 14.225 46.7313 16.1348 47.7123 16.5138C48.6932 16.8928 48.4607 18.6556 49.1563 18.5848C49.8518 18.5141 49.4901 16.4961 49.4901 16.4961C49.4901 16.4961 50.1357 16.0988 50.6345 16.2167C51.1333 16.3346 51.4743 11.3161 50.6465 10.6417C49.8186 9.96726 48.8038 10.1792 48.8038 10.1792C48.8038 10.1792 48.2754 8.46561 46.8325 8.41687C45.3897 8.36814 37.8622 9.94645 38.8248 11.5499C37.2756 11.7081 38.5362 13.276 38.5362 13.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0714 23.901L49.7429 18.9204C49.7429 18.9204 50.8777 18.889 51.021 17.2337C51.1642 15.5783 49.457 16.2817 49.457 16.2817",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.75 23.1764V24.8942",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0227 23.1764V24.8942",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1364 23.1764V24.8942",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.25 23.1764V24.8942",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6818 23.1764V24.8942",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0715 44.206C43.2201 43.6822 42.015 40.3824 41.044 39.7352C40.0729 39.0881 38.2682 39.6777 36.8399 39.9645C35.4116 40.2514 36.2139 41.1849 36.2139 41.1849C36.2139 41.1849 35.6679 41.9632 36.3965 42.3048C36.1266 42.5962 36.2331 43.2948 37.4997 43.1589C37.1222 43.6821 37.6464 43.8969 38.3145 43.8969C38.9827 43.8969 39.9444 43.8969 39.9444 43.8969C39.9444 43.8969 39.9202 44.238 40.9682 45.08C42.0161 45.9221 43.4737 47.5809 43.4737 47.5809C43.4737 47.5809 45.0387 47.7246 45.5107 45.9044",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0715 44.206C43.2201 43.6822 42.015 40.3824 41.044 39.7352C40.0729 39.0881 38.2682 39.6777 36.8399 39.9645C35.4116 40.2514 36.2139 41.1849 36.2139 41.1849C36.2139 41.1849 35.6679 41.9632 36.3965 42.3048C36.1266 42.5962 36.2331 43.2948 37.4997 43.1589C37.1222 43.6821 37.6464 43.8969 38.3145 43.8969C38.9827 43.8969 39.9444 43.8969 39.9444 43.8969C39.9444 43.8969 39.9202 44.238 40.9682 45.08C42.0161 45.9221 43.4737 47.5809 43.4737 47.5809C43.4737 47.5809 45.0387 47.7246 45.5107 45.9044",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2139 41.1849L38.7855 40.7844C38.7855 40.7844 40.2341 40.1756 40.6019 40.6803",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3837 42.3716L39.1251 41.9141C39.1251 41.9141 40.3514 41.5302 40.7716 41.9141",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4996 43.1589L39.6991 42.804C39.6991 42.804 40.4992 42.6919 40.7716 42.9815",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2273 45.0008C45.2273 45.0008 47.8366 44.5196 50.7211 46.0098C53.6056 47.5 57.2816 47.6769 58.75 49.0998",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6136 47.382L56.8409 35.9819",
    stroke: "#0F0B28",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0228 36.1381L45.2273 42.0724",
    stroke: "#0F0B28",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersBenefit);
export default __webpack_public_path__ + "static/media/members-benefit.715a03d095a1b4d9411488bf34a398c5.svg";
export { ForwardRef as ReactComponent };